import { render, staticRenderFns } from "./ClassSubjects.vue?vue&type=template&id=a5744fdc&"
import script from "./ClassSubjects.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjects.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSubjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports